import { render, staticRenderFns } from "./default.vue?vue&type=template&id=5fc8c048&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=5fc8c048&prod&scoped=true&lang=scss"
import style1 from "./default.vue?vue&type=style&index=1&id=5fc8c048&prod&lang=scss&scoped=true"
import style2 from "./default.vue?vue&type=style&index=2&id=5fc8c048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8c048",
  null
  
)

export default component.exports